import utils from 'src/components/Organisms/Form/utils'

const config = utils.injectTranslation({
  id: 'AddContactDetailsForm',
  path: 'onboarding.forms.CorporateAccount.WebsiteAccessForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'fullName',
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr',
      },
      content: [
        {
          componentType: 'input',
          submitValidation: 'email',
          props: {
            name: 'email',
            required: true,
          },
        },
      ],
    },
  ],
})

export default config
